// A link-styled action (FR-047; research R14): text in `prt`, a 44 px target, button role unless it
// navigates. Extra props pass through, so it works inside expo-router's `Link asChild`.
import { PressableTarget, type PressableTargetProps } from "./PressableTarget";
import { Text } from "./Text";

export type LinkButtonProps = Omit<
  PressableTargetProps,
  "children" | "accessibilityRole"
> & {
  children: string;
  role?: "button" | "link";
  /** When the visible text alone is ambiguous, e.g. "Edit" in a list row. */
  accessibilityLabel?: string;
};

export function LinkButton({
  children,
  role = "button",
  disabled,
  accessibilityLabel,
  ...rest
}: LinkButtonProps) {
  return (
    <PressableTarget
      {...rest}
      accessibilityRole={role}
      accessibilityLabel={accessibilityLabel ?? children}
      accessibilityState={{ disabled: !!disabled }}
      disabled={disabled}
    >
      <Text tone={disabled ? "muted" : "primary"} weight="semiBold">
        {children}
      </Text>
    </PressableTarget>
  );
}
